export enum PredmetOpazanjaType {
    Stetnici = 0,
    Fenofaze = 1,
}
